import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

declare global {
  interface Window {
    _paq?: any[];
  }
}

@Injectable({ providedIn: 'root' })
export class RouteTrackingService {
  private readonly maxHistoryLength = 10;
  private history: string[] = [];

  constructor(private router: Router) {}

  init(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history.push(event.url);
        if (this.history.length > this.maxHistoryLength) {
          this.history.shift();
        }
      }
    });
  }

  getUrlFromHistory(howManyRoutesAgo: number): string {
    const index = this.history.length - howManyRoutesAgo;
    if (index < 0 || index >= this.history.length) {
      console.warn('Route requested not stored in history. Falling back to root.');
      return '/';
    }
    return this.history[this.history.length - howManyRoutesAgo];
  }

  removeLastUrl(): void {
    this.history.pop();
  }
}
